import { useEffect, useState } from "react";

import Api from "../../../shared/api/api";

import AssessmentsAdminList from "../components/AssessmentsAdminList";
import LockedAdminAssessments from "../components/LockedAdminAssessments";
import PdfAdminList from "../components/PdfAdminList";
import QuestionsAdminList from "../components/QuestionsAdminList";
import TestsAdminList from "../components/TestsAdminList";
import UsersAdminList from "../components/UsersAdminList";
import WarningMsg from "../components/WarningMsg";

import "../styles/AdminPage.css";

export default function AdminPage() {
  const [lockedAssessments, setLockedAssessments] =
    useState([]);

  const [users, setUsers] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  const [tests, setTests] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [usersActiveModal, setUsersActiveModal] =
    useState(false);

  const [testsActiveModal, setTestsActiveModal] =
    useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadAdminData = async () => {
      setIsLoading(true);
      setError("");

      try {
        const [
          lockedResponse,
          usersResponse,
          assessmentsResponse,
          pdfResponse,
          testsResponse,
          questionsResponse,
        ] = await Promise.all([
          Api.getAll("lock"),
          Api.getAll("users"),
          Api.getAll("assessment"),
          Api.getAll("pdf"),
          Api.getAll("test"),
          Api.getAll("questions"),
        ]);

        if (!isMounted) {
          return;
        }

        setLockedAssessments(
          Array.isArray(lockedResponse)
            ? lockedResponse
            : []
        );

        setUsers(
          Array.isArray(usersResponse)
            ? usersResponse
            : []
        );

        setAssessments(
          Array.isArray(assessmentsResponse)
            ? assessmentsResponse
            : []
        );

        setPdfs(
          Array.isArray(pdfResponse)
            ? pdfResponse
            : []
        );

        setTests(
          Array.isArray(testsResponse)
            ? testsResponse
            : []
        );

        setQuestions(
          Array.isArray(questionsResponse)
            ? questionsResponse
            : []
        );

        const responses = [
          lockedResponse,
          usersResponse,
          assessmentsResponse,
          pdfResponse,
          testsResponse,
          questionsResponse,
        ];

        const responseError = responses.find(
          (response) => response?.error
        );

        if (responseError?.error) {
          setError(responseError.error);
        }
      } catch (requestError) {
        console.error(
          "Unable to load FourH admin data:",
          requestError
        );

        if (isMounted) {
          setError(
            requestError?.message ||
              "The admin data could not be loaded."
          );
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadAdminData();

    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return (
      <main className="fourHAdminPage">
        <p role="status">Loading admin data...</p>
      </main>
    );
  }

  return (
    <main className="fourHAdminPage">
      {error && (
        <WarningMsg
          message={error}
          type="error"
        />
      )}

      <div className="adminLists">
        <LockedAdminAssessments
          lockedAssessments={lockedAssessments}
          setLockedAssessments={
            setLockedAssessments
          }
        />

        <UsersAdminList
          users={users}
          setUsers={setUsers}
          usersActiveModal={usersActiveModal}
          setUsersActiveModal={
            setUsersActiveModal
          }
        />

        <AssessmentsAdminList
          assessments={assessments}
          setAssessments={setAssessments}
        />

        <PdfAdminList
          pdfs={pdfs}
          setPdfs={setPdfs}
        />

        <TestsAdminList
          tests={tests}
          setTests={setTests}
          testsActiveModal={testsActiveModal}
          setTestsActiveModal={
            setTestsActiveModal
          }
        />

        <QuestionsAdminList
          questions={questions}
          setQuestions={setQuestions}
          tests={tests}
        />
      </div>
    </main>
  );
}